import { useState, useEffect } from 'react';

export const useDebounceForLoading = (value: boolean, initialValue: boolean = true): boolean => {
  const [debouncedValue, setDebouncedValue] = useState(initialValue);
  const displayLoadingComponentsDelay = 100;

  useEffect(() => {
    let handler: NodeJS.Timeout;

    if (value === false) {
      handler = setTimeout(() => {
        setDebouncedValue(value);
      }, displayLoadingComponentsDelay);
    } else {
      setDebouncedValue(value);
    }

    return () => {
      clearTimeout(handler);
    };
  }, [value]);

  return debouncedValue;
};
